module.exports = __webpack_public_path__ + "img/brand-cases27.6c5e707c.png";